<template>
  <div class="zxh" v-show="show">
    <span>{{ tip }}</span>

    <svg @click="show = false;" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M3.70722 3.80527L12.7451 12.8432M3.25467 12.8432L12.2926 3.80527" stroke="#CACACA" stroke-width="1.28" stroke-linecap="round"/>
    </svg>
  </div>
</template>

<script>
import "@/utils/flexible";
export default {
    data() {
        return {
            tip:'此页面由中讯证券提供  www.aigupiao8.com',
            show:true,
        };
    },
    methods:{

    }
}

</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.zxh{
    display: flex;
    padding: rem2(10px) rem2(15px) rem2(10px) rem2(12px);
    align-items: center;
    font-size: rem2(14px);
    border-bottom: rem2(1px) solid #EBEBEB;
    background: #FFF;
    color: #AFAFAF;
    justify-content: space-between;
    svg{
        width: rem2(16px);
        height: rem2(16px);
    }
}
</style>